<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5">
          <Icon icon="alertOctagon" :xlarge="true" color="red" class="v-icon" />
        </v-card-title>
        <v-card-text>{{ $t("varify-logout") }}</v-card-text>
        <v-card-actions>
          <v-btn color="switchq darken-1" text @click="logout">
            {{ $t("out") }}
          </v-btn>
          <v-btn color="red darken-1" text @click="cancelLogout">
            {{ $t("cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  name: "LogOutModal",
  props: ["activator"],
  data() {
    return {
      dialog: false,
    };
  },

  created() {
    this.dialog = this.activator;
  },
  watch: {
    activator() {
      this.dialog = this.activator;
    },
  },
  methods: {
    cancelLogout() {
      this.$logger.action("logout_modal.cancel_clicked");
      this.$emit("close");
    },
    async logout() {
      const logoutAttemptId = this.$logger.getSessionId
        ? `logout_${Date.now()}_${this.$logger.getSessionId()}`
        : `logout_${Date.now()}`;
      this.$logger.action("logout_modal.confirm_clicked", {
        outcome: "started",
        logoutAttemptId,
      });
      this.$logger.auth("auth.logout_modal_confirmed", {
        reason: "user_requested",
        source: "logout_modal",
        logoutAttemptId,
      });
      const signOutPromise = this.$store.dispatch("user/signOut", {
        reason: "user_requested",
        source: "logout_modal",
        logoutAttemptId,
      });

      this.$store.dispatch("user/clearClientSessionData", {
        reason: "user_requested",
      });
      this.$store.dispatch("user/clearSessionState");

      this.$logger.auth("auth.logout_navigation_started", {
        reason: "user_requested",
        source: "logout_modal",
        logoutAttemptId,
        toPath: "/login",
      });
      await this.$router
        .replace("/login")
        .then(() => {
          this.$logger.auth("auth.logout_navigation_completed", {
            reason: "user_requested",
            source: "logout_modal",
            logoutAttemptId,
            toPath: "/login",
          });
        })
        .catch((error) => {
          this.$logger.warn("auth.logout_navigation_failed", {
            reason: "user_requested",
            source: "logout_modal",
            logoutAttemptId,
            toPath: "/login",
            name: error && error.name,
            message: error && error.message,
          });
        });

      signOutPromise.catch((error) => {
        this.$logger.warn("auth.logout_background_failed", {
          reason: "user_requested",
          source: "logout_modal",
          logoutAttemptId,
          name: error && error.name,
          message: error && error.message,
        });
      });

      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.v-icon {
  margin: 0 auto;
}
.v-dialog > .v-card > .v-card__actions {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
</style>
